import { Loading } from '@lib/components'
import cx from 'classnames'
import type React from 'react'

import { URL } from '../URL'
import css from './ExternalLinkLoading.module.scss'

type Props = {
  title?: string | null
  url: string
  isArrowMode: boolean

  onRedirect: () => void
}

export const ExternalLinkLoading: React.FC<Props> = ({
  title,
  url,
  isArrowMode,
  onRedirect,
}) => {
  return (
    <div>
      <div className={css.loading}>
        <Loading color="gray" type="smallx2" />
      </div>
      <div
        className={cx(css.body, {
          [css.arrowMode]: isArrowMode,
        })}
      >
        {title && (
          <div className={css.title}>
            <div>{title}</div>
          </div>
        )}

        <URL url={url} onRedirect={onRedirect} />
      </div>
    </div>
  )
}
